import ErrorFallbacks from "@src/components/ErrorFallbacks";
import React from "react";
import { quitWebviewDeeplink } from "@src/utils/goBack";

const SomethingWentWrongPage = () => {
  return <ErrorFallbacks statusCode={500} />;
};

SomethingWentWrongPage.getLayoutProps = () => ({
  handleBack: quitWebviewDeeplink,
  noPullToRefresh: true,
  noFooter: true,
});

export default SomethingWentWrongPage;
